import { Record, Map, List } from "immutable";

class ScoreCardRecord extends Record({
    id: null,
    score: new Map({}),
    groups: new List([]),
    details: new Map({})
}) {
    get composite_score() {
        return (
            this.score
                .map((value, key) => {
                    return +value * +this.getGroupWeight(key);
                })
                .reduce((agg, _) => _ + agg, 0) / this.total_weight
        );
    }

    getGroupWeight(groupName) {
        return (this.groups.find(_ => _.label === groupName) || { weight: 0 })
            .weight;
    }

    get total_weight() {
        return this.groups.reduce((agg, _) => +_.weight + agg, 0);
    }
}

export { ScoreCardRecord };
